// Node Module Imports
import React from 'react'

import { Paging, Results, SearchBox, SearchProvider } from '@elastic/react-search-ui'
import { StaticImage } from 'gatsby-plugin-image'
import { FaSearch } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import '@elastic/react-search-ui-views/lib/styles/styles.css'

// Components Imports
import { getSearchProviderConfig } from '../../../config/swiftype'
import { User } from '../../redux/actions'
import { displaySearchModalSelector } from '../../redux/selectors'
import ModalBasic from '../modals/ModalBasic'
import AutocompleteResults from '../search/AutocompleteResults'
import Result from '../search/Result'

import { makeID } from '../../utils/string'

let SPCache = null

const SearchBar = ({ className }) => {
  const dispatch = useDispatch()
  const displaySearchModal = useSelector(displaySearchModalSelector)

  if (SPCache === null) {
    SPCache = getSearchProviderConfig(() => {
      dispatch(User.showSearchModal(true))
    })
  }

  const InputView = ({ getAutocomplete, getInputProps }) => {
    const id = makeID()
    return (
      <div className="sui-search-box__wrapper">
        <FaSearch className="mag" />
        <p className="sr-only" id={id}></p>

        <input
          {...getInputProps({
            'aria-label': 'Search',
            placeholder: 'Search',
            'aria-labelledby': id,
          })}
        />
        {getAutocomplete()}
      </div>
    )
  }

  return (
    <div className={className}>
      <SearchProvider config={SPCache}>
        {typeof window !== 'undefined' && (
          <SearchBox
            autocompleteResults
            autocompleteView={(props) => <AutocompleteResults {...props} />}
            inputView={InputView}
          />
        )}
        {displaySearchModal && (
          <ModalBasic closeModal={() => dispatch(User.showSearchModal(false))}>
            {typeof window !== 'undefined' && (
              <SearchBox
                autocompleteResults
                autocompleteView={(props) => <AutocompleteResults {...props} />}
                className="mb-8"
              />
            )}
            <Results className="pl-0" resultView={(props) => <Result {...props} />} />
            <Paging />
          </ModalBasic>
        )}
      </SearchProvider>
    </div>
  )
}

export default styled(SearchBar)`
  position: relative;

  .sui-search-box__wrapper {
    position: relative;

    input {
      border: none;
      border-radius: 2px;
      padding: 0.75rem 0.75rem 0.75rem 2.5rem;
      width: 100%;
    }

    .mag {
      max-height: 18px;
      opacity: 0.75;
      position: absolute;
      top: 50%;
      bottom: 0;
      left: 12px;
      transform: translateY(-50%);
      z-index: 1;
    }
  }
`
